import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wifi-01",
  "use": "icon-wifi-01-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"icon-wifi-01\">\r\n  <defs>\r\n    <style>\r\n      #icon-wifi-01 .cls-1 {\r\n        fill: #347aeb;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-wifi-01_l_752\" data-name=\"l 752\" class=\"cls-1\" d=\"M60.2,143l3-4a5,5,0,0,0-6,0l3,4m0-15a14.94,14.94,0,0,0-9,3l1.5,2a12.5,12.5,0,0,1,15,0l1.5-2a14.94,14.94,0,0,0-9-3m0,5a9.948,9.948,0,0,0-6,2l1.5,2a7.5,7.5,0,0,1,9,0l1.5-2A9.948,9.948,0,0,0,60.2,133Z\" transform=\"translate(-51.2 -128)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol